import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { Container } from '../styled/containers';
import generateQS from '../styled/background-image';

const mobileRatio = '56%';
const desktopRatio = '32%';
const imageSizes = {
  mobile: [608, 342], // 56%
  tablet: [959, 306], // 32%
  desktop: [1108, 355], // 32%
};

export const ImageWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  padding-top: ${mobileRatio};
  background-color: ${({ theme }) => theme.palette.lightBackground};
  background-image: ${({ $image: image, $alignImage: alignImage }) =>
    image && generateQS({ image, imageSizes, alignImage, size: 'mobile' })};
  background-size: cover;

  ${breakpoint.tablet`
    padding-top: ${desktopRatio};
    background-image: ${({ $image: image, $alignImage: alignImage }) =>
      image && generateQS({ image, imageSizes, alignImage, size: 'tablet' })};
  `};

  ${breakpoint.desktop`
    background-image: ${({ $image: image, $alignImage: alignImage }) =>
      image && generateQS({ image, imageSizes, alignImage, size: 'desktop' })};
  `}
`;

export const StyledContainer = styled(Container)`
  ${breakpoint.desktop`
    padding: ${({ theme }) =>
      `${theme.spacing.medium} ${theme.spacing.large} 0`};
  `}
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.xlarge};
`;

export const TextWrapper = styled.div`
  h3 {
    margin-top: 0;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  p:last-child {
    margin-bottom: ${({ theme }) => theme.spacing.medium};
  }
`;

export const LinkBoxWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
